import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import CallDetailPanel from './CallDetailPanel';
import { formatDetailsSubtitle } from './callDetailFormat';

/**
 * Модальная обёртка над `CallDetailPanel` — тот самый вид, что открывается «глазом»
 * в журнале звонков.
 *
 * `isLoading` / `error` нужны точкам входа, у которых на руках только `callId`
 * (примеры звонков из графиков, deep-link): диалог открывается сразу, содержимое догружается.
 */
const CallDetailDialog = ({ call, open, onOpenChange, isLoading = false, error = null }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent trackId="calls.detail" className="max-w-3xl">
      <DialogHeader>
        <DialogTitle>Детали звонка</DialogTitle>
        <DialogDescription>{formatDetailsSubtitle(call)}</DialogDescription>
      </DialogHeader>

      <div className="space-y-4 max-h-[70vh] overflow-y-auto pr-1">
        {error && (
          <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">{error}</div>
        )}
        {isLoading && !error && <p className="text-sm text-muted-foreground">Загрузка...</p>}
        {!isLoading && !error && !call && (
          <p className="text-sm text-muted-foreground">Звонок не найден.</p>
        )}
        <CallDetailPanel call={call} />
      </div>
    </DialogContent>
  </Dialog>
);

export default CallDetailDialog;
